import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
    },
    headerInputContainer: {
        flexDirection: "row",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center"
    },
    companyCardContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    cardImage: {
        width: 95,
        height: 95
    },
    companyContent: {
        flex: 1,
        flexDirection: "column",
        alignItems: "flex-start",
        flexShrink: 1
    },
    companyNavigation: {
        justifyContent: "flex-start",
        alignSelf: "flex-start"
    },
    memberCardContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    memberCardContent: {
        flex: 1,
        flexDirection: "column",
        alignItems: "flex-start",
        flexShrink: 1
    },
    memberCardNavigation: {
        justifyContent: "center",
        alignSelf: "center"
    },
    width100: {
        width: "100%"
    },
    sectorChipContainer: {
        alignSelf: "baseline"
    },
    sheetHeaderContainer: {
        alignItems: "center"
    },
    loadingContainer: {
        alignItems: "center",
        justifyContent: "center"
    },
    flex1: {
        flex: 1
    }
});
export default stylesheet;
